import { useEffect } from 'react';

const useRecaptcha = (siteKey) => {
  useEffect(() => {
    const scriptId = 'recaptcha-script';
    if (document.getElementById(scriptId)) return;

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    document.body.appendChild(script);
  }, [siteKey]);

  const executeRecaptcha = async (action) => {
    if (!window.grecaptcha) {
      console.error('Recaptcha not loaded');
      return null;
    }

    const token = await window.grecaptcha.execute(siteKey, { action });
    return token;
  };

  return { executeRecaptcha };
};

export default useRecaptcha;